import React, {useEffect, useState} from "react";

import { i18n } from 'translate/i18n'

import Page from "components/Page";
import { SelectUsers } from "components/Select";

import {Link} from "react-router-dom";
import {Outlet, useNavigate, Navigate} from "react-router";

import {useUser} from "store/providers/app";
import {loginRequest} from "../../auth/authAzure";
import {getGroups} from "../../services/Graph.service";
import {useMsal} from "@azure/msal-react";

const Users = ({permissions}) => {

    // const {rules} = useUser()
    //
    // const isAuthorized = permissions
    //     .some(permission => {
    //         return rules.includes(permission)
    //     })

    const navigate = useNavigate()

    const handleOnChange = (data) => {
        navigate(`edit/${data.value}`)
    }



    // if (!isAuthorized) {
    //     return <Navigate to={'/unauthorized'}/>
    // }

    return (
        <Page label={i18n.t('titlePage.users')} icon="bi bi-person-circle">

            <div className="card mt-3 border-0 shadow-sm">
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <SelectUsers onChangeUsers={(e) => handleOnChange(e)}/>
                        </div>
                    </div>
                </div>
            </div>

            <Outlet />
        </Page>
    );
}

export default Users
